module.exports = __webpack_public_path__ + "img/20AÑOS.962f7d5b.svg";